module.exports = __webpack_public_path__ + "static/media/ensuite_light.27226327.jpg";